"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var BrandType;
(function (BrandType) {
    BrandType["Movie"] = "Movie";
    BrandType["Show"] = "Show";
    BrandType["Episode"] = "Episode";
    // for compatibility, when use an id of show episode in detail page
    BrandType["ShowEpisode"] = "episode";
    BrandType["Channel"] = "Channel";
    BrandType["Collection"] = "Collection";
    BrandType["PayPerViewEvent"] = "PayPerViewEvent";
    BrandType["PayPerViewEventProgram"] = "PayPerViewEventProgram";
})(BrandType = exports.BrandType || (exports.BrandType = {}));
//# sourceMappingURL=BrandType.js.map